export class ReportPatientStatementParamsModel {
  ProvidersId: string[];
  PracticeId: number;
  PracticeLocations: string[];
  initialDate: Date;
  endDate: Date;
  isProvider: boolean;
  isPractice: boolean;
  statementNote: string;
}

export class ReportTransactionParamsModel{
  ProvidersId: string[];
  PracticeId: number;
  PracticeLocations: string[];
  initialDate: Date;
  endDate: Date;
  isProvider: boolean;
  isPractice: boolean;
  transactionType: string;
}

export class ReportVoidedTransactionParamsModel{
  ProvidersId: string[];
  PracticeId: number;
  PracticeLocations: string[];
  initialDate: Date;
  endDate: Date;
  isProvider: boolean;
  isPractice: boolean;
  isOrderByDateCharged: boolean;
}

export class ReportLedgerTransactionParamsModel{
  ProvidersId: string[];
  PracticeId: number;
  PracticeLocations: string[];
  initialDate: Date;
  endDate: Date;
  isProvider: boolean;
  isPractice: boolean;
  showProductionReport: boolean;
  showReceiptReport: boolean;
  showActivityReport: boolean;
  isActivityGroupByDoctor: boolean;
  showBankDepositsReport: boolean;
  showTransactionsReport: boolean;
  showTransactionCash: boolean;
  showTransactionCheck: boolean;
  showTransactionCreditCard: boolean;
  showTransactionDebit: boolean;
  showTransactionOther: boolean;
  isNewPage: boolean;
}

export class ReportFinancialAuditParamsModel{
  initialDate: Date;
  endDate: Date;
  PracticeId: number;
}

export class ReportListOfAppointmentsParamsModel{
  initialDate: Date;
  endDate: Date;
  PracticeId: number;
  PracticeLocations: string[];
  ProvidersId: string[];
  isProvider: boolean;
  isPractice: boolean;
}

export class ReportCreditBalanceParamsModel{
  PracticeId: number;
  PracticeLocations: string[];
  ProvidersId: string[];
  isProvider: boolean;
  isPractice: boolean;
  isAllProviders: boolean;
  isAllLocations: boolean;
}

export class ReportCreditCardReceiptParamsModel{
  PaymentId: string;
  PatientId: string;
  LedgerId: string;
}

export class ReportRecallParamsModel{
  initialDate: Date;
  endDate: Date;
  PracticeId: number;
  PracticeLocations: string[];
  ProvidersId: string[];
  isProvider: boolean;
  isPractice: boolean;
}

export class ReportOutstandigClaimsModel {
  isEClaims: boolean;
	isADAForm: boolean;
	Over30: boolean;
	Over60: boolean;
	Over90: boolean;
  PracticeId: number;
  PracticeLocations: string[];
  ProvidersId: string[];
  isProvider: boolean;
  isPractice: boolean;
  }

  export class ReportFeeCalculationReportParamsModel {
    isOrderedByDate: boolean;
    isOrderedByToothCode: boolean;
  }
  export class ReportBankDepositsParamsModel {
    isCash: boolean;
    isCheck: boolean;
    isCashandCheck: boolean;
  }
  export class ReportReferringAnalysisModel {
    isProvider: boolean;
    isPractice: boolean;
    PracticeLocations: string[];
    ProvidersId: string[];
    initialDate: Date;
    endDate: Date;
    isAll: boolean;
    IncludePerDoctor: boolean;
    IncludePerCode: boolean;
    IncludeBreakDown: boolean;

  }
  export class ReportPatientsNeedAppointmentParamsModel {
    PracticeLocations: string[];
    initialDate: Date;
    endDate: Date;
    isNewOnly: boolean;
  }
  export class ReportRecallAppointmentParamsModel {
    isProvider: boolean;
    isPractice: boolean;
    PracticeLocations: string[];
    ProvidersId: string[];
    initialDate: Date;
    endDate: Date;
    isFollowUp: boolean;
    isAllProviders: boolean;
    isAllLocations: boolean;
  }
  export class ReportCallListParamsModel {
    isProvider: boolean;
    isPractice: boolean;
    PracticeLocations: string[];
    isAllProviders: boolean;
    isAllLocations: boolean;
    ProvidersId: string[];
    initialDate: Date;
    endDate: Date;
  }
  export class ReportCollectionParamsModel {
    isProvider: boolean;
    isAllProviders: boolean;
    isAllLocations: boolean;
    isPractice: boolean;
    PracticeLocations: string[];
    ProvidersId: string[];
  }
  export class ReportUnappliedCreditsParamsModel {
    isProvider: boolean;
    isAllProviders: boolean;
    isAllLocations: boolean;
    isPractice: boolean;
    PracticeLocations: string[];
    ProvidersId: string[];
  }
  export class ReportDeletedAnesthesiaParamsModel {
    initialDate: Date;
    endDate: Date;
  }
  export class ReportPatientCaseReferralsParamsModel {
    initialDate: Date;
    endDate: Date;
  }
export class ReportReportsToBeCompletedParamsModel {
  isProvider: boolean;
  isPractice: boolean;
  LocationsIdList: string;
  ProvidersIdList: string;
}

export class ReportsToBeCompletedListModel {
  PatientId: string;
  PatientName: string;
  CaseFinalReportID: string;
  Appointment: Date;
}

export class FinalReportToBeCompletedModel {
  PatientId: string;
  PatientName: string;
  ToothInfo: string;
  ExamDate: Date;
  CaseFinalReportID: string;
  Appointment: Date;
  CaseStatusId: string;
  CaseStatusDate: Date;
  ReferralReportSent: boolean;
  ReferralReportDate: Date;
  ClaimCreatedSent: boolean;
  ClaimDate: Date;
  DiagnosticReport: boolean;
  DiagnosticReportDate: Date;
  DiagnosticReportSize: string;
  InterimReport: boolean;
  InterimReportDate: Date;
  ReportListSameAsFinal: boolean;
  SendDate1: Date;
  SendTo1: string;
  SendDate2: Date;
  SendTo2: string;
  NoReportNeeded: boolean;
}
